<template>
  <div
    class="wb-primary-btn"
    :class="[type, disabled || isLoading ? 'disabled' : '']"
    :style="cssStyle"
    @click="$emit('tap')"
  >
    <template v-if="!isLoading">
      <slot name="prefix" />
      <span>{{ msg }}</span>
      <slot name="suffix" />
    </template>
    <template v-else>
      <img class="loading-icon" src="@/assets/loading_small_white.webp" />
    </template>
  </div>
</template>

<script>
  export default {
    name: 'wb-primary-btn',

    props: {
      type: {
        type: String,
        default: 'default' // default / primary / plain / sub / orange
      },
      disabled: {
        type: Boolean,
        default: false
      },
      msg: {
        type: String,
        default: ''
      },
      cssStyle: {
        type: Object,
        default: () => {}
      },
      isLoading: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/theme/themes.scss';

  .wb-primary-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: auto;
    height: 44px;
    font-size: 16px;
    cursor: pointer;
    border-radius: 22px;
    line-height: 44px;
    text-align: center;
    user-select: none;

    &.default {
      background: #ffffff;
      border: 1px solid #cacaca;
      color: #777777;

      &:active {
        background: #eeeeee;
        border: 1px solid #cacaca;
      }
    }

    &.primary {
      background: $mainColor;
      color: #ffffff;

      &:active {
        background: $mainColorActive;
      }
    }

    &.plain {
      background: #ffffff;
      border: 1px solid $mainColor;
      color: $mainColor;

      &:active {
        background: #eeeeee;
      }
    }

    &.sub {
      background: #fff0f1;
      border: 1px solid #fff0f1;
      color: $mainColor;

      &:active {
        background: #f7e7e8;
        border: 1px solid #f7e7e8;
      }
    }

    &.orange {
      background: #ff6e08;
      color: #ffffff;
      box-shadow: 0px 3px 8px 0px rgba(255, 110, 8, 0.16);

      &:active {
        background: #eb8a46;
      }
    }

    &.disabled {
      cursor: not-allowed;
      pointer-events: none;

      &.default {
        background: #eeeeee;
        border: none;
        color: #bbbbbb;
      }

      &.primary {
        background: $mainColorDisabled;
        color: #ffffff;
      }

      &.orange {
        background: #fabd93;
        color: #ffffff;
      }
    }

    .loading-icon {
      width: 16px;
      height: 16px;
    }
  }
</style>
